import { left, map, fold } from 'fp-ts/lib/Either';
import { pipe } from 'fp-ts/lib/pipeable';
import { Vector } from './Vector';
import { Vector2D } from './Vector2D';
/**
 * a {@link Vector} with a dimensionality of 3
 */
export class Vector3D {
    _vec;
    static fromPosition = (p) => new Vector3D(p.value());
    static fromMatrix(m) {
        if (m.rows() === 1 && m.columns() === 3) {
            return pipe(m.row(0), map(x => new Vector3D(x.value())));
        }
        else if (m.columns() === 1 && m.rows() === 3) {
            return pipe(m.column(0), map(x => new Vector3D(x.value())));
        }
        else {
            return left('Validation Error - unable to construct Vector3D from Matrix');
        }
    }
    static unitX() {
        return new Vector3D([1, 0, 0]);
    }
    static unitY() {
        return new Vector3D([0, 1, 0]);
    }
    static unitZ() {
        return new Vector3D([0, 0, 1]);
    }
    constructor(initialContents) {
        this._vec = new Vector(3, initialContents);
    }
    dimensionality() {
        return this._vec.dimensionality();
    }
    value() {
        return this._vec.value();
    }
    dot(right) {
        return this._vec.dot(right);
    }
    scale(scalar) {
        return new Vector3D(this._vec.scale(scalar).value());
    }
    sum(right) {
        return pipe(this._vec.sum(right), fold((error) => {
            throw new Error(error);
        }, (vec) => new Vector3D(vec.value())));
    }
    sub(right) {
        return pipe(this._vec.sub(right), fold((error) => {
            throw new Error(error);
        }, vec => new Vector3D(vec.value())));
    }
    normalise() {
        return new Vector3D(this._vec.normalise().value());
    }
    cross(right) {
        return new Vector3D(this._vec.cross(right).value());
    }
    neg() {
        return new Vector3D(this._vec.neg().value());
    }
    mag() {
        return this._vec.mag();
    }
    toString() {
        return `Vec${[...this.value()]}`;
    }
    xz() {
        return new Vector2D([this.value()[0], this.value()[2]]);
    }
}
//# sourceMappingURL=Vector3D.js.map